import { cardPreviewActions } from './card-preview-slice';
import config from './config';
import { getCsrfToken } from './config';

export const fetchOccasionData = (occasionId) => {
    return async (dispatch) => {
      const fetchData = async () => {
        const csrfToken = getCsrfToken();
        const response = await fetch(
          config.settings.apiEndpoint + 'api/requests/GetEnrollmentOccasion/' + occasionId,
          {
            method: 'GET',
            credentials: "include",
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': csrfToken
            }
          }
        );
  
        if (!response.ok) {
          throw new Error('Could not fetch occasion data!');
        }
  
        const data = await response.json();
  
        return data;
      };
  
      try {
        const occasionData = await fetchData();
        dispatch(
          cardPreviewActions.setSelectedOccasionState(occasionData)
        );
      } catch (error) {
        // dispatch error msg
        console.log(error);
      }
    };
  };